export class LogEvent {
	static readonly type = '[Event] Log';
	constructor(public event: string, public payload: {}) {}
}
